import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-kostenstelle-list-view',
  imports: [],
  templateUrl: './kostenstelle.list-view.html',
  styleUrls: ['./kostenstelle.list-view.css'],
})
export class KostenstelleListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
